import { ConfigurationCTAUrlResponse } from '../../../Monitor/types';

export const EmptyUrlObject: ConfigurationCTAUrlResponse = {
  id: '',
  urlLink: '',
  monitorDetails: [],
};

export const testUrlRegex = /(https?:\/\/)?([\da-z.-]+)\.([a-z]{2,6})([/\w.-]*)*\/?/;
